import React from "react";
import styles from "./Product.module.css";
import ProductArtwork from "../ProductArtwork/ProductArtwork";
import type { ProductItem } from "../../types/catalog";
import { useI18n } from "../../i18n/I18n";

interface ProductProps extends ProductItem {
  addToCart: () => void;
  onOpen: () => void;
}

function Product({ addToCart, onOpen, ...product }: ProductProps) {
  const { language, t } = useI18n();
  const openFromKeyboard = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onOpen();
    }
  };

  return (
    <article className={styles.product} onClick={onOpen} onKeyDown={openFromKeyboard} role="button" tabIndex={0} aria-label={`${t("detailsAbout")} ${product.title}`}>
      <div className={styles.imageWrap}>
        <ProductArtwork product={product} />
        <span className={styles.availability}>{t("inStock")}</span>
      </div>
      <div className={styles.copy}>
        <span className={styles.brand}>{product.brand}</span>
        <h3>{product.title}</h3>
        <p>{t("checked")}</p>
      </div>
      <div className={styles.buy}>
        <b>{product.price.toLocaleString(language === "uk" ? "uk-UA" : "en-US")} ₴</b>
        <button onClick={(event) => { event.stopPropagation(); addToCart(); }} aria-label={`${t("addToCart")}: ${product.title}`}>+</button>
      </div>
    </article>
  );
}

export default Product;
